// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_FB5","cls2":"ExportFormatModal-cls2_QST ExportFormatModal-cls1_FB5"};